// Models
import adjustmentList from '../models/adjustmentsList';

import {
    FETCH_ADJUSTMENTS_REQUEST,
    FETCH_ADJUSTMENTS_SUCCESS,
    FETCH_ADJUSTMENTS_ERROR,
    HIDE_ADJUSTMENT_LOADER,
    SHOW_ADJUSTMENT_LOADER,
    GENERATE_ADJUSTMENT_REPORT_REQUEST,
    GENERATE_ADJUSTMENT_REPORT_SUCCESS,
    GENERATE_ADJUSTMENT_REPORT_ERROR,
    RESET_ADJUSTMENT_STATE,
    CREATE_ADJUSTMENT_SUCCESS,
    CREATE_ADJUSTMENT_ERROR,
    CREATE_ADJUSTMENT_RESET,
} from './adjustments.constants';

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    statusData: {
        details: {},
        error: {},
    },
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: {},
        error: {},
    },
    createAdjustment: {
        isLoading: false,
        isSuccess: false,
    },
    downloadReport: {},
    isLoading: false,
};

export const adjustmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADJUSTMENTS_SUCCESS: {
            const createAdjustmentData = new adjustmentList(action.payload);
            return {
                ...state,
                ...createAdjustmentData,
                error: {},
            };
        }
        case FETCH_ADJUSTMENTS_REQUEST:
            return {
                ...state,
                error: {},
            };
        case FETCH_ADJUSTMENTS_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case GENERATE_ADJUSTMENT_REPORT_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GENERATE_ADJUSTMENT_REPORT_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_ADJUSTMENT_REPORT_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case CREATE_ADJUSTMENT_SUCCESS:
            return {
                ...state,
                error: {},
                createAdjustment: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case CREATE_ADJUSTMENT_ERROR:
            return {
                ...state,
                createAdjustment: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: false,
                },
            };
        case CREATE_ADJUSTMENT_RESET:
            return {
                ...state,
                createAdjustment: {
                    isSuccess: false,
                    message: '',
                    isLoading: false,
                    data: {},
                },
            };
        case SHOW_ADJUSTMENT_LOADER:
            return { ...state, isLoading: true };
        case HIDE_ADJUSTMENT_LOADER:
            return { ...state, isLoading: false };
        case RESET_ADJUSTMENT_STATE:
            return initialState;
        default:
            return state;
    }
};
